import { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    List,
    ListItem,
    ListItemText,
    FormControlLabel,
    Checkbox,
    Stack,
} from '@mui/material';

const ZeroDialog = ({
    open,
    onClose,
    onConfirm,
    selectedGames,
    resetExp,
    setResetExp,
    resetCoin,
    setResetCoin,
}) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle
                sx={{
                    fontFamily: 'Poppins',
                    fontSize: '20px',
                    lineHeight: '28px',
                    fontWeight: '500',
                    color: '#0C3466',
                    marginBottom: '8px',
                }}
            >
                Tem certeza de que deseja zerar as pontuações dos jogos abaixo?
            </DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: '16px',
                            lineHeight: '24px',
                            fontWeight: '600',
                            color: '#0C3466',
                        }}
                    >
                        Os seguintes jogos terão suas pontuações zeradas:
                    </Typography>
                    <List>
                        {selectedGames.map((game) => (
                            <ListItem key={game.id}>
                                <ListItemText
                                    primary={game.name}
                                    sx={{
                                        fontFamily: 'Poppins',
                                        fontSize: '12px',
                                        lineHeight: '24px',
                                        fontWeight: '600',
                                        color: '#0C3466',
                                    }}
                                />
                            </ListItem>
                        ))}
                    </List>
                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: '16px',
                            lineHeight: '24px',
                            fontWeight: '600',
                            color: '#0C3466',
                        }}
                    >
                        Qual progresso dos usuários você deseja zerar?
                    </Typography>
                    <Stack direction="row">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={resetExp}
                                    onChange={() => setResetExp(!resetExp)}
                                />
                            }
                            label="Experiência"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={resetCoin}
                                    onChange={() => setResetCoin(!resetCoin)}
                                />
                            }
                            label="Moedas"
                        />
                    </Stack>
                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: '14px',
                            lineHeight: '24px',
                            fontWeight: '600',
                            color: 'red',
                        }}
                    >
                        Essa ação é irreversível.
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined">
                    Cancelar
                </Button>
                <Button
                    onClick={onConfirm}
                    variant="contained"
                    sx={{
                        backgroundColor: '#E63946',
                        color: '#FFFFFF',
                        ':hover': {
                            backgroundColor: '#FFFFFF',
                            color: '#E63946',
                        },
                    }}
                >
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ZeroDialog;
